module.exports = __webpack_public_path__ + "static/media/la.826e1710.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/la.svg
// module id = 2138
// module chunks = 0